import React, { useEffect, useRef, useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import linksTvService from '../../../../services/tvs/linksTvService';
import DialogCrud from '../../shared/DialogCrud.jsx';
import FormCadastrarLinks from './FormCadastrarLinks.jsx';
import { mostrarMensagemErro, mostrarMensagemSucesso } from '../helpers/toast';
import { statusTemplate, urlTemplate } from '../helpers/bodyTemplateColunas.jsx';
import Vincular from '../../shared/Vincular.jsx';
import vincularLinkGrupo from '../../../../services/tvs/vincular-link-grupo';
import grupoTvService from '../../../../services/tvs/grupoTvService';
import { retornarDiferentes } from '../helpers/vinculos';

// eslint-disable-next-line max-lines-per-function
export default function DataTableLinks({ loadTable,setLoadTable,mensagemToast }) {
    const [dataLinks,setDataLinks] = useState([]);
    const [loadingLoadTable,setLoadingLoadTable] = useState(false);
    const [loadingEdit,setLoadingEdit] = useState(false);
    const [loadingVincular,setLoadingVincular] = useState(false);
    const [linkEdicao,setLinkEdicao] = useState(null);
    const [openModal,setOpenModal] = useState(false);
    const [openVincular,setOpenVincular] = useState(false);
    const [gruposVinculados,setGruposVinculados] = useState([]);
    const [gruposDisponivel,setGruposDisponiveis] = useState([]);
    const refGrupos = useRef(null);

    useEffect(() => {
        (async () => {
            setLoadingLoadTable(true);

            const responseDataLinks = await linksTvService.getLinks();

            setDataLinks(responseDataLinks);
            setLoadingLoadTable(false);
        })();
    }, [loadTable]);
    
    useEffect(() => {
        (async () => {
            try {
                if (openVincular){
                    const responseGruposSelecionados = await vincularLinkGrupo.getGruposVinculados(linkEdicao.id);

                    const { data } = await grupoTvService.getGrupo();

                    const gruposAptos = data.filter(grupo => grupo.status === 1);

                    if (responseGruposSelecionados.length === 0) {
                        refGrupos.current = responseGruposSelecionados;
                        setGruposVinculados(responseGruposSelecionados);
                        setGruposDisponiveis(gruposAptos);

                        return;
                    }

                    const gruposDisponiveis = gruposAptos.map(grupo => {
                        if (!responseGruposSelecionados.find(grupoSelecionado => grupoSelecionado.idGrupo === grupo.id)){
                            return grupo;
                        }
                    }).filter(grp=> grp !== undefined);
    
                    setGruposDisponiveis(gruposDisponiveis);
                    setGruposVinculados(responseGruposSelecionados);
                    refGrupos.current = responseGruposSelecionados;
                }
            } catch (error) {
                mostrarMensagemErro(mensagemToast,'Problema ao buscar os grupos, tente novamente!');
            }
        })();
    }, [openVincular]);

    const handleEdit = async dados => {
        try {
            setLoadingEdit(true);

            const { nome,url,status } =dados;

            await linksTvService.putLink({ nome,
                url,
                status: status ? 1 : 0 },linkEdicao.id);
            setLoadingEdit(false); 
            setOpenModal(false);
            setLoadTable(!loadTable);
            mostrarMensagemSucesso(mensagemToast, 'Edição realizada com sucesso.');   
        } catch (error) {
            setOpenModal(false);
            mostrarMensagemErro(mensagemToast, 'Falha ao editar, tente novamente mais tarde.');
        }
    };
    
    const handleActionEdit = rowData => {
        setOpenModal(true);

        const { nome,url,status,id } = rowData;

        setLinkEdicao({ nome,
            url,
            status ,
            id });
    };
     
    const handleActionVincular = rowData => {
        setOpenVincular(true);

        const { id,nome } = rowData;

        setLinkEdicao({ nome,
            id });
    };

    const actionTemplate = rowData => <div className="acoes" style={{ display: 'flex',
        gap: '8px',
        justifyItems: 'center',
        justifyContent: 'space-evenly',
        color: '#03258C'  }}>
    
        <i className="pi pi-pencil"  onClick={handleActionEdit.bind(this,rowData)} style={{ 'fontSize': '2em',
            cursor: 'pointer' }}></i>
    </div>;
   
    const onSubmitVincularGrupos = async (idLink,fonte,alvo) => {
        try{
            setLoadingVincular(true);

            const comparador = retornarDiferentes(refGrupos.current.map(({ idGrupo })=> idGrupo),alvo.map(grupo => grupo.idGrupo || grupo.id));

            await vincularLinkGrupo.deleteGruposVinculadosLinkId(idLink, fonte.map(grupo => grupo.idGrupo || grupo.id));

            if (comparador.houveMudanca && comparador.futuro.length > 0){
                await vincularLinkGrupo.postGrupoVinculadosLinkdId(idLink, comparador.futuro);
            }
            
            setOpenVincular(false);
            setLoadingVincular(false);
            mostrarMensagemSucesso(mensagemToast, 'Vinculos estabelicidos com sucesso.');
        } catch (e) {
            setLoadingVincular(false);
            mostrarMensagemErro(mensagemToast, 'Problema para estabelecer vinculos.');
        }
    };

    const vincularGrupoTemplate = rowData => (            
        <div className="acoes" style={{ display: 'flex',
            gap: '8px',
            justifyItems: 'center',
            justifyContent: 'space-evenly',
            color: '#03258C'  }}>
            <i className="pi pi pi-link"
                onClick={handleActionVincular.bind(this,rowData)} style={{ 'fontSize': '2em',
                    color: '#03258C' }}></i>
        </div>
    );

    return (
        <>
            <DialogCrud loading={loadingEdit} title={'Editar link'} openModal={openModal} setOpenModal={setOpenModal}>
                <FormCadastrarLinks edit handleSubmitFormik={handleEdit} initialValues={linkEdicao}/>
            </DialogCrud>
            <Vincular 
                onSubmitBotaoAcao={onSubmitVincularGrupos}
                setFonte={setGruposDisponiveis} 
                setAlvo={setGruposVinculados} 
                fonteDados={gruposDisponivel} 
                titleModal={'Vincular link'}
                idParaPostDelete ={linkEdicao?.id} 
                fonteTitulo={'Grupos'} 
                alvoTitulo={'Grupos vinculados'} 
                alvoDados={gruposVinculados} 
                openModal={openVincular} 
                isFetching={loadingVincular}
                setOpenModal={setOpenVincular}/>
            <DataTable
                loading={loadingLoadTable}
                value={dataLinks} 
                responsive  dataKey="id" rowHover
                paginator rows={10} emptyMessage="Sem links encontrados" currentPageReportTemplate="Mostrando {first} de {last} de {totalRecords} registros"
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown" rowsPerPageOptions={[10,25,50]}>
                <Column style={{ width: '30%' }} filter field="nome" header="Nome do link" />
                <Column body={urlTemplate} field="url" header="Url" />
                <Column style={{ width: '10%' }}body={statusTemplate} field="status" header="Status" />
                <Column style={{ width: '10%' }}body={vincularGrupoTemplate}  header="Vincular grupos" />
                <Column style={{ width: '10%' }} body={actionTemplate} header="Ações" />
            </DataTable>
        </>           
    );
}
